import { jsx, jsxs } from "react/jsx-runtime";
import { useRef, useEffect } from "react";
import styled from "styled-components";
import { IconSearch } from "@bynder/icons";
import { Input } from "./Input.js";
import { token } from "./token.js";
import { useDropdownContext } from "./context3.js";
function SearchInput({
  onChange,
  actionButton,
  ...props
}) {
  const inputRef = useRef(null);
  const {
    dispatch
  } = useDropdownContext();
  const {
    menuId
  } = useDropdownContext();
  function handleChange(value) {
    var _a, _b;
    (_b = (_a = document.querySelector(`#${menuId}`)) == null ? void 0 : _a.scrollTo) == null ? void 0 : _b.call(_a, {
      top: 0
    });
    onChange(value);
  }
  useEffect(() => {
    var _a;
    (_a = inputRef.current) == null ? void 0 : _a.focus();
  }, []);
  useEffect(() => {
    dispatch({
      type: "set-search-presence"
    });
  }, [dispatch]);
  return /* @__PURE__ */ jsx(Container, {
    children: /* @__PURE__ */ jsxs(Inner, {
      children: [/* @__PURE__ */ jsx(InputWrapper, {
        children: /* @__PURE__ */ jsx(Input, {
          inputRef,
          hasClearButton: true,
          icon: /* @__PURE__ */ jsx(IconSearch, {}),
          onChange: handleChange,
          ...props
        })
      }), actionButton]
    })
  });
}
const Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1gdl4z6-0"
})(["--container-top-padding-compensation:calc(", " * -1);position:sticky;top:var(--container-top-padding-compensation);z-index:1;box-sizing:content-box;height:40px;margin-top:var(--container-top-padding-compensation);padding:", ";background:", ";box-shadow:", ";"], token.spacing3, token.spacing4, token.white, token.elevationStatic);
const Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-1gdl4z6-1"
})(["position:absolute;top:", ";right:", ";left:", ";display:flex;gap:", ";"], token.spacing4, token.spacing4, token.spacing4, token.spacing3);
const InputWrapper = styled.div.withConfig({
  displayName: "InputWrapper",
  componentId: "sc-1gdl4z6-2"
})(["flex:1;min-width:0;"]);
export {
  SearchInput
};
//# sourceMappingURL=SearchInput.js.map
